import { useCurrentUser } from "../../../../../AuthWrapper2/hooks/useCurrentUser.js";
import { TypeBackgroundColors, metadataLastSawDatePropName } from "../../../constants.js";
import { useMemo } from "react";
import { Tag } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/SystemInfo/shared/components/SystemInfosList/components/SystemInfoListItem.tsx
function SystemInfoListItem({ excerpt, timestamp, title, type }) {
	const { userClientMetadata } = useCurrentUser();
	const lastSawDate = userClientMetadata?.webClientData?.[metadataLastSawDatePropName];
	if (!excerpt && !title) return null;
	const isNew = useMemo(() => {
		if (!lastSawDate || !timestamp) return false;
		return lastSawDate < timestamp;
	}, []);
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs("h2", {
		className: "mb-xs space-x-xs text-md font-medium",
		children: [
			/* @__PURE__ */ jsx("span", {
				className: "text-color-strong tracking-wide",
				children: title
			}),
			/* @__PURE__ */ jsx(Tag, {
				value: type,
				backgroundColor: TypeBackgroundColors[type],
				textColor: "var(--color-text)"
			}),
			isNew && /* @__PURE__ */ jsx(Tag, {
				value: "new",
				variant: "main"
			})
		]
	}), !!excerpt && /* @__PURE__ */ jsx("div", {
		className: "line-clamp-4 text-sm",
		children: excerpt
	})] });
}
export { SystemInfoListItem };

//# sourceMappingURL=SystemInfoListItem.js.map